module.exports = __webpack_public_path__ + "static/media/indonesia.41b2e1d3.jpg";